import type { MaintenanceWorkOrderChecklistStatusDto } from "@bi/types";
import { CHECK_LABEL } from "./work-order-checklist-ui";

/**
 * O check dos itens da O.S.: caixa estilizada (não o checkbox do navegador) que
 * mostra a situação em forma e cor — ✓ realizado, ✕ não realizado, — não se aplica.
 * Cor nunca é o único sinal: cada estado tem seu símbolo.
 */
const ESTILO: Record<MaintenanceWorkOrderChecklistStatusDto, string> = {
  pending: "border-gray-300 bg-white text-transparent hover:border-tm-500",
  done: "border-tm-600 bg-tm-600 text-white",
  not_done: "border-danger-600 bg-danger-600 text-white",
  not_applicable: "border-gray-400 bg-gray-200 text-gray-600",
};

export function CheckMark({
  status, onClick, disabled, label,
}: { status: MaintenanceWorkOrderChecklistStatusDto; onClick?: () => void; disabled?: boolean; label: string }) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={status === "done" ? true : status === "pending" ? false : "mixed"}
      aria-label={`${label}: ${CHECK_LABEL[status]}`}
      title={CHECK_LABEL[status]}
      disabled={disabled}
      onClick={onClick}
      className={`flex h-5 w-5 shrink-0 items-center justify-center rounded border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-tm-500 disabled:cursor-default ${ESTILO[status]}`}
    >
      {status === "done" && (
        <svg viewBox="0 0 16 16" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M3.5 8.5l3 3 6-7" />
        </svg>
      )}
      {status === "not_done" && (
        <svg viewBox="0 0 16 16" className="h-3 w-3" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden>
          <path d="M4 4l8 8M12 4l-8 8" />
        </svg>
      )}
      {status === "not_applicable" && (
        <svg viewBox="0 0 16 16" className="h-3 w-3" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden>
          <path d="M3.5 8h9" />
        </svg>
      )}
    </button>
  );
}
